import { MakeCall } from './createMakeCall';

const validatePhone =
  (makeCall: MakeCall) => (data: { countryCode: string; phone: string }) =>
    makeCall<undefined>('POST', '/api/v2/validation/phone', {
      data,
    });
export { validatePhone };
